import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { ShippingCosts } from 'server/detail-requests/ShippingCost';
import { useViewport } from '@sbt-web/hooks';
import { Button, Icon } from '@sbt-web/ui';
import { FlowDialog } from '@/client/components/Detail/FlowDialog';
import classes from './index.module.scss';
export type InfoBoxProps = {
  shippingCosts: ShippingCosts;
  showPayPal: boolean;
  isPro: boolean;
};
export const InfoBox = t0 => {
  const $ = _c(30);
  const {
    shippingCosts,
    showPayPal,
    isPro
  } = t0;
  const {
    isMobile
  } = useViewport();
  const [modalOpen, setModalOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Icon name="shipping_promo" fillColor="currentColor" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = shippingCosts.type === "self" || !shippingCosts.min.partial ? "Spedizione: " : "Spedizione a partire da ";
  let t3;
  if ($[1] !== t2) {
    t3 = <p className="body-text small">{t2}</p>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = shippingCosts.type === "self" ? shippingCosts.cost : shippingCosts.min.cost;
  let t5;
  if ($[3] !== t4) {
    t5 = <p className="body-text semibold small">{t4}</p>;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t3 || $[6] !== t5) {
    t6 = <div className={classes.shippingCost}>{t1}<div className={classes.shippingCopy}>{t3}{t5}</div></div>;
    $[5] = t3;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== isPro) {
    t7 = isPro && <div className={classes.proReturns}><Icon name="Clock" fillColor="currentColor" /><div className={classes.returnsCopy}><p className="body-text small">Reso entro</p><p className="body-text semibold small">14 giorni</p></div></div>;
    $[8] = isPro;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className={classes.buyerProtection}><Icon name="Shield" fillColor="currentColor" /><p className="body-text small">Protezione Acquisti</p></div>;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t10;
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Icon name="Lock" fillColor="currentColor" />;
    t10 = <p className="body-text small">Pagamento Sicuro</p>;
    $[11] = t10;
    $[12] = t9;
  } else {
    t10 = $[11];
    t9 = $[12];
  }
  let t11;
  let t12;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <img src={`${process.env.NEXT_PUBLIC_ASSETS_BASE_URL}/static/icons/payments/mastercard.png`} alt="Mastercard" width="20" height="21" />;
    t12 = <img src={`${process.env.NEXT_PUBLIC_ASSETS_BASE_URL}/static/icons/payments/visa.png`} alt="Visa" width="26" height="21" />;
    $[13] = t11;
    $[14] = t12;
  } else {
    t11 = $[13];
    t12 = $[14];
  }
  let t13;
  if ($[15] !== showPayPal) {
    t13 = showPayPal && <img src={`${process.env.NEXT_PUBLIC_ASSETS_BASE_URL}/static/icons/payments/paypal.png`} alt="PayPal" width="30" height="21" />;
    $[15] = showPayPal;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== t13) {
    t14 = <div className={classes.paymentMethods}>{t9}{t10}<div className={classes.icons}>{t11}{t12}{t13}</div></div>;
    $[17] = t13;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Button onClick={() => {
      setModalOpen(true);
    }} size="small" design="text" slim={true}>Scopri di più</Button>;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = () => {
      setModalOpen(false);
    };
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  const t17 = `${process.env.NEXT_PUBLIC_AREARISERVATA_BASE_URL}/transazioni/scopri-servizio-tuttosubito?user_type=${isPro ? "B2C" : "C2C"}`;
  let t18;
  if ($[21] !== isMobile || $[22] !== modalOpen || $[23] !== t17) {
    t18 = <div>{t15}<FlowDialog fullscreen={isMobile} opened={modalOpen} onCloseIntent={t16} flowUrl={t17} /></div>;
    $[21] = isMobile;
    $[22] = modalOpen;
    $[23] = t17;
    $[24] = t18;
  } else {
    t18 = $[24];
  }
  let t19;
  if ($[25] !== t14 || $[26] !== t18 || $[27] !== t6 || $[28] !== t7) {
    t19 = <section className={classes.infoBox}>{t6}{t7}{t8}{t14}{t18}</section>;
    $[25] = t14;
    $[26] = t18;
    $[27] = t6;
    $[28] = t7;
    $[29] = t19;
  } else {
    t19 = $[29];
  }
  return t19;
};